import React from 'react';
import { motion } from 'framer-motion';
const TARGET_VIDEO = 'https://cdn.magicpatterns.com/uploads/fK77WxB2HyzuY11vhjPwkS/Esto es para ti si (1).mp4';
export function TargetAudienceSection() {
  return <section className="w-full bg-white p-0 m-0 leading-[0]" data-id="element-319">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="w-full" data-id="element-320">
        <video src={TARGET_VIDEO} autoPlay loop muted playsInline className="w-full h-auto block m-0 p-0" data-id="element-321" />
      </motion.div>
    </section>;
}